import { render } from "./QuizType3.vue?vue&type=template&id=7e3dc0f9&scoped=true"
import script from "./QuizType3.vue?vue&type=script&lang=js"
export * from "./QuizType3.vue?vue&type=script&lang=js"

import "./QuizType3.vue?vue&type=style&index=0&id=7e3dc0f9&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e3dc0f9"]])

export default __exports__